import { render, staticRenderFns } from "./TripCard.vue?vue&type=template&id=27c62a72&scoped=true&"
import script from "./TripCard.vue?vue&type=script&lang=js&"
export * from "./TripCard.vue?vue&type=script&lang=js&"
import style0 from "./TripCard.vue?vue&type=style&index=0&id=27c62a72&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c62a72",
  null
  
)

export default component.exports